import React from "react";
import Canvas from "./Canvas/canvas";
import Controls from "./Canvas/Controls/Controls";
import { ContextProvider } from "./Context/context";
import { ContextProvider as MenuContextProvider } from "./Canvas/Controls/BrushMenus/TopMenu/TopMenuContext";
import { ColorTheme } from "./TypesAndConstants/const";

export default class SketchContainer extends React.Component {
  render() {
    return (
      <div className={"appWrapper"} style={{ color: ColorTheme.primaryText }}>
        <ContextProvider>
          <MenuContextProvider>
            <Controls />
          </MenuContextProvider>
          <Canvas />
        </ContextProvider>
        <div
          style={{
            position: "absolute",
            bottom: "-5%",
            backgroundImage: `url("${require("../Assets/splats_top.png")}")`,
            width: "500px",
            left: "-2%",
            transform: "rotate(180deg)",
            height: " 416px",
            backgroundRepeat: "no-repeat",
            overflow: "hidden",
          }}
        />
      </div>
    );
  }
}
